import { state } from "./State";
import type * as Types from "./types";

export const initialize = (invitationId: string, company: Types.Company, invitation: Types.Invitation): void => {
  state.invitationId = invitationId;
  state.company = company;
  state.invitation = invitation;
};
